import { useRouter } from './useRouter';
/**
 * Возвращает теущую локацию и возможность перехода на новую локацию
 *
 * ```typescript
 * import React from "react";
 * import { useLocation } from "@okapi/router-react";

 * function Shared() {
 *  const [path, push] = useLocation();
 *  return <h2>Shared page { path }</h2>
 * }
 * ```
 */
export function useLocation() {
    const router = useRouter();
    return [router.getPath(), router.navigate];
}
